/** Demo inventory when /api/v1/devices returns nothing (standalone demo). */
export const DEMO_WIRELESS_APS = [
  {
    id: '00000000-0000-0000-0000-000000000101',
    name: 'AP-Lobby-01',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6E',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000102',
    name: 'AP-Conference-02',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6E',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000103',
    name: 'AP-OpenOffice-03',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6E',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000104',
    name: 'AP-Cafeteria-04',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000105',
    name: 'AP-Lab-05',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000106',
    name: 'AP-Reception-06',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6E',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000107',
    name: 'AP-Training-07',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6E',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000108',
    name: 'AP-Breakout-08',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000109',
    name: 'AP-Storage-09',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000110',
    name: 'AP-ITRoom-10',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6E',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000111',
    name: 'AP-Terrace-11',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6E',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000112',
    name: 'AP-Pantry-12',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000113',
    name: 'AP-Exec-13',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6E',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000114',
    name: 'AP-Warehouse-14',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6',
    vendor: 'VVDN',
  },
  {
    id: '00000000-0000-0000-0000-000000000115',
    name: 'AP-Guest-15',
    type: 'WIRELESS_AP',
    model: 'VVDN-WiFi-6E',
    vendor: 'VVDN',
  },
] as const

type DeviceLike = {
  id?: string
  name?: string
  model?: string
  type?: string
  deviceType?: string
}

export function isWirelessApDevice(d: DeviceLike): boolean {
  const n = String(d.name ?? '').toLowerCase()
  const m = String(d.model ?? '').toLowerCase()
  const t = String(d.type ?? d.deviceType ?? '').toUpperCase()
  return (
    t === 'WIRELESS_AP' ||
    t === 'TELECOM_LTE_AP' ||
    n.includes('ap') ||
    m.includes('ap') ||
    n.includes('wifi')
  )
}

export function mapWirelessInventory(data: DeviceLike[]): { id: string; name: string; model?: string }[] {
  return data
    .filter(isWirelessApDevice)
    .map(d => ({ id: String(d.id), name: String(d.name), model: d.model ? String(d.model) : undefined }))
}

export function withDemoInventoryFallback(inventory: { id: string; name: string; model?: string }[]) {
  if (inventory.length > 0) return inventory
  return DEMO_WIRELESS_APS.map(d => ({ id: d.id, name: d.name, model: d.model }))
}
